export const players = [
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'Finley' },
  { name: 'BEADLE' },
  { name: 'FINLEY' },
  { name: 'HARRIES' },
  { name: 'GRANT' },
  { name: 'BROWN' },
  { name: 'ALFIE' },
  { name: 'EVANS' },
  { name: 'LINES' },
  { name: 'BODIN' },
  { name: 'AARON' },
  { name: 'OLLIE' },
  { name: 'ARABS' },
  { name: 'ANSSI' },
  { name: 'AGOGO' },
  { name: 'GEOFF' },
  { name: 'HOOLE' },
  { name: 'LEAHY' },
  { name: 'BELLY' },
  { name: 'GOULD' },
  { name: 'HOWIE' },
  { name: 'MEHEW' },
  { name: 'YATES' },
  { name: 'BIGGS' },
  { name: 'JONES' },
  { name: 'BATER' },
  { name: 'DEVON' },
  { name: 'COLES' },
  { name: 'BYRON' },
  { name: 'JASON' },
  { name: 'ELLIS' },
  { name: 'GERRY' },
  { name: 'SMART' },
  { name: 'JAMIE' },
  { name: 'PETER' },
  { name: 'EADIE' },
  { name: 'SHORE' },
  { name: 'JASON' },
  { name: 'WALLY' },
  { name: 'IRENE' },
  { name: 'GLENN' },
  { name: 'GLENN' },
  { name: 'ALVIN' },
  { name: 'WHITE' },
  { name: 'SAMMY' },
  { name: 'PULIS' },
  { name: 'NIGEL' },
  { name: 'BRIAN' },
  { name: 'NOLAN' },
  { name: 'NIXON' },
  { name: 'LEWIS' },
  { name: 'SIMON' },
  { name: 'PERRY' },
  { name: 'DAVID' },
  { name: 'SMITH' },
  { name: 'BILLY' },
  { name: 'BOBBY' },
  { name: 'REECE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'CLARKE' },
  { name: 'DISLAY' },
  { name: 'MEGSON' },
  { name: 'PITT' },
  { name: 'PARKIN' },
  { name: 'PRINCE' },
  { name: 'NATHAN' },
  { name: 'MOUSSA' },
  { name: 'TAYLOR' },
  { name: 'FINLEY' },
  { name: 'LIMBS' },
  { name: 'TREES' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'MANSE' },
  { name: 'CLARKE' },
  { name: 'DISLAY' },
  { name: 'MEGSON' },
  { name: 'PITT' },
  { name: 'PARKIN' },
  { name: 'PRINCE' },
  { name: 'NATHAN' },
  { name: 'MOUSSA' },
  { name: 'TAYLOR' },
  { name: 'FINLEY' },
  { name: 'LIMBS' },
  { name: 'TREES' },
  { name: 'CLARKE' },
  { name: 'DISLAY' },
  { name: 'MEGSON' },
  { name: 'PITT' },
  { name: 'PARKIN' },
  { name: 'PRINCE' },
  { name: 'NATHAN' },
  { name: 'MOUSSA' },
  { name: 'TAYLOR' },
  { name: 'FINLEY' },
  { name: 'JARMAN' },
  { name: 'JONES' },
  { name: 'MARTYN' },
  { name: 'MILLER' },
  { name: 'PRINCE' },
  { name: 'PULIS' },
  { name: 'PULIS' },
  { name: 'ROOST' },
  { name: 'STUART' },
  { name: 'TANNER' },
  { name: 'TAYLOR' },
  { name: 'WHITE' },
  { name: 'STEVE' },
  { name: 'DUKE' },
  { name: 'BUBB' },
  { name: 'GEOFF' },
  { name: 'ARCHER' },
  { name: 'MEHEW' },
  { name: 'PARKES' },
  { name: 'THEMEM' },
  { name: 'BILLY' },
  { name: 'GURNEY' },
  { name: 'COLES' },
  { name: 'TOVEY' },
  { name: 'KELLY' },
  { name: 'THOMMO' },
  { name: 'HINTON' },
  { name: 'TUTTON' },
  { name: 'HUNT' },
  { name: 'ADMIN' },
  { name: 'IGOE' },
  { name: 'WALKER' },
  { name: 'AUSTIN' },
  { name: 'EASTER' },
  { name: 'LIMBS' },
  { name: 'LOFT' },
  { name: 'CHRIS' },
  // { name: 'ELLIOT' },
  // { name: 'VITALIJS' },
  // { name: 'ELLIOTT' },
  // { name: 'LOCKYER' },
  // { name: 'PENRICE' },
  // { name: 'PIRATES' },
];

export const keyboardLineOne = [
  'q',
  'w',
  'e',
  'r',
  't',
  'y',
  'u',
  'i',
  'o',
  'p',
];
export const keyboardLineTwo = ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'];
export const keyboardLineThree = ['z', 'x', 'c', 'v', 'b', 'n', 'm'];
